import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAlert } from 'react-alert';
import {
  compensi,
  compensiStudio,
  compensiStudioExport,
} from '../../lib/fetch/dashboard';
import DashboardDetailCompensiStudioPresentational from './DashboardDetailCompensiStudioPresentational';
import { useLoading } from '../../commons/Loading';
import { useAuth } from '../../commons/Auth';
import {
  useQueryParams,
  withDefault,
  StringParam,
  NumberParam,
} from 'use-query-params';
import axios from 'axios';
const { REACT_APP_DEFAULT_PAGINATION_LIMIT } = process.env;

function DashboardDetailCompensi(props) {
  const { showLoading, hideLoading } = useLoading();
  const [data, setData] = useState([]);
  const [dataExport, setDataExport] = useState([]);
  const [total, setTotal] = useState(0);
  const [{ newToken } = {}] = useAuth();
  const { t } = useTranslation('DASHBOARD');
  const alert = useAlert();
  const [isReady, setIsReady] = useState(false);

  const [selectedInvoices, setSelectedInvoices] = useState([]);

  const [query, setQuery] = useQueryParams({
    search: withDefault(StringParam, ''),
    admin: withDefault(StringParam, ''),
    year: NumberParam,
  });

  const { limit, offset, search, paid, admin, year } = query;

  const fetchCompensi = async () => {
    showLoading();

    const { error, headers, data } = await compensiStudio({
      year,
      search,
      newToken,
      limit,
      offset,
      admin,
    });

    if (error) {
      hideLoading();
      alert.error(t('COMMON:GENERIC_ERROR'));
      return;
    }

    setData(data);
    setSelectedInvoices([]);
    setTotal(Number(headers['x-total-count']));
    hideLoading();
  };

  const fetchCompensiExport = async () => {
    showLoading();
    setIsReady(false);

    const { error, headers, data } = await compensiStudio({
      limit: 5000,
      offset: 0,
      year,
      search,
      newToken,
      admin,
    });

    if (error) {
      hideLoading();
      alert.error(t('COMMON:GENERIC_ERROR'));
      return;
    }

    setDataExport(data);
    setIsReady(true);
    hideLoading();
  };

  useEffect(() => {
    fetchCompensi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [year, search, offset, limit, admin]);

  function onFilter(queryDiff) {
    if (
      (queryDiff.search && queryDiff.search !== search) || // first search
      (search && queryDiff.search === '') || // search deleted
      (queryDiff.admin && queryDiff.admin !== admin) || // first search
      (admin && queryDiff.admin === '') || // search deleted
      (queryDiff.limit && queryDiff.limit !== limit) ||
      (queryDiff.year && queryDiff.year !== year) ||
      (search && queryDiff.year === '')
    ) {
      queryDiff.offset = 0; // return to first page
    }
    setQuery(queryDiff);
  }

  function onSelectChange(_id) {
    if (selectedInvoices.includes(_id)) {
      return setSelectedInvoices((selectedInvoices) =>
        selectedInvoices.filter((invoiceId) => invoiceId !== _id)
      );
    }
    setSelectedInvoices((selectedInvoices) => [...selectedInvoices, _id]);
  }

  const onSelectAll = (data) => {
    setSelectedInvoices(data.map(({ _id }) => _id));
  };

  return (
    <DashboardDetailCompensiStudioPresentational
      data={data}
      dataExport={dataExport}
      year={year}
      query={query}
      total={total}
      onFilter={onFilter}
      selectedInvoices={selectedInvoices}
      onSelectChange={onSelectChange}
      onSelectAll={onSelectAll}
      fetchCompensiExport={fetchCompensiExport}
      isReady={isReady}
      setIsReady={setIsReady}
      {...props}
    />
  );
}

export default DashboardDetailCompensi;
